import * as ToggleGroupPrimitive from '@radix-ui/react-toggle-group';
import classNames from 'classnames';

import './segmented-control.scss';

import type { SegmentedControlProps } from './types';

export const SegmentedControl = ({
  disabled,
  fullWidth,
  fixedHeight,
  value,
  onValueChange,
  options,
  allowDeselect,
  className,
}: SegmentedControlProps) => {
  return (
    <div
      className={classNames(
        'payflow-ui segmented-control',
        fullWidth && 'fullwidth',
        fixedHeight && 'fixed-height',
        className
      )}
    >
      <ToggleGroupPrimitive.Root
        className="segmented-control__root"
        onValueChange={(newValue) => {
          if (!onValueChange) {
            return;
          }

          if (!newValue && !allowDeselect) {
            return;
          }

          onValueChange(newValue);
        }}
        type="single"
        value={value}
        disabled={disabled}
      >
        {options.map((option) => (
          <ToggleGroupPrimitive.Item
            key={option.value}
            className="segmented-control__item"
            value={option.value}
            disabled={option.disabled}
          >
            <div className="segmented-control__label">
              <div className="segmented-control__label-active rt-SegmentedControlItemLabelActive">{option.label}</div>
              <div className="segmented-control__label-inactive rt-SegmentedControlItemLabelInactive">
                {option.label}
              </div>
            </div>
          </ToggleGroupPrimitive.Item>
        ))}
        <div className="segmented-control__indicator" />
      </ToggleGroupPrimitive.Root>
    </div>
  );
};
